import * as preregisterApplicantsTypes from './preregisterApplicantsTypes';

const initialState = {
  caseManagerId: null,
  AvailableApplicanttableData:  {
    columns:[
      "markSelection", "caseManagerId", "applicant", "caseId", "personId", "client", "eyStatus", "casePhase"
    ],
    cases:[],
    AvailableApplicantSeletableItem:[],
    total: 0
  },
  selectedApplicantTableData: {
    columns:[
      "markSelection", "caseManagerId", "applicant", "caseId", "personId", "client", "eyStatus", "casePhase"
    ],
    cases:[],
    selectedApplicantSelectableItem:[],
    total: 0
  },
  filters: {},
  caseDocuments: [],
  showFilterModal: false,
  isLoading: false,
  showToastMessage: false,
  toastMessage: '',
  eyStatusCountry:'',
  onsearchFilter: false,
};

const moveApplicantReducer = (state = initialState, action) => {
  switch (action.type) {
   
    // case caseTypes.SET_CASES_PARAMS_SUCCESS: {
    //   return { ...state, casesPayload: action.payload };
    // }
    


    // case caseTypes.SET_POPULATE_PAYLOAD_SUCCESS: {
    //   return { ...state, populatePayload: action.flag };
    // }
    case preregisterApplicantsTypes.GET_CASES_SUCCESS: {
      const arr = action.payload;

      arr && arr.cases.forEach(object => {
        object.markSelection = false;
      });
      arr.columns.unshift('markSelection')
      return { ...state, AvailableApplicanttableData: {...arr, AvailableApplicantSeletableItem: []}, onsearchFilter:false};
    }
    case preregisterApplicantsTypes.MARK_AVAILABLE_APPLICANT_ROW_SELECTION: {
      let availableApplicantNew = state.AvailableApplicanttableData.cases.slice();
      availableApplicantNew[action.payload.origRowIndex].markSelection = action.isChecked;
      let AvailableApplicantSeletableItem = availableApplicantNew.filter(val =>{
        return val.markSelection == true;
      })
      return {
        ...state,
        AvailableApplicanttableData: { ...state.AvailableApplicanttableData, cases: availableApplicantNew, AvailableApplicantSeletableItem: AvailableApplicantSeletableItem },
      };
    }
    case preregisterApplicantsTypes.MARK_SELECT_APPLICANT_ROW_SELECTION: {
      let selectedApplicantNew = state.selectedApplicantTableData.cases.slice();
          selectedApplicantNew[action.payload.origRowIndex].markSelection = action.isChecked;
      let selectedApplicantSelectableItem = selectedApplicantNew.filter(val =>{
        return val.markSelection == true;
      })
      return {
        ...state,
        selectedApplicantTableData: { ...state.selectedApplicantTableData, cases: selectedApplicantNew, selectedApplicantSelectableItem: selectedApplicantSelectableItem },
      };

    }

    case preregisterApplicantsTypes.MARK_ALL_AVAILABLE_APPLICANT_ROW_SELECTION: {
      let availableApplicantNew = state.AvailableApplicanttableData.cases.slice();
      availableApplicantNew.forEach(ele => {
        ele.markSelection = action.isChecked;
      })
      let AvailableApplicantSeletableItem = availableApplicantNew.filter(val =>{
        return val.markSelection == true;
      })
      return {
        ...state,
        AvailableApplicanttableData: { ...state.AvailableApplicanttableData, cases: availableApplicantNew, AvailableApplicantSeletableItem: AvailableApplicantSeletableItem },
      };

    }

    case preregisterApplicantsTypes.MARK_ALL_SELECT_APPLICANT_ROW_SELECTION: {
      let selectedApplicantNew = state.selectedApplicantTableData.cases.slice();
          selectedApplicantNew.forEach(ele => {
            ele.markSelection = action.isChecked;
          });
      let selectedApplicantSelectableItem = selectedApplicantNew.filter(val =>{
        return val.markSelection == true;
      })
      return {
        ...state,
        selectedApplicantTableData: { ...state.selectedApplicantTableData, cases: selectedApplicantNew, selectedApplicantSelectableItem: selectedApplicantSelectableItem },
      };

    }


    case preregisterApplicantsTypes.MOVE_APPLICANT_TO_SELECTED_TABLE: {
      let remainingAvailableApplicantItem = state.AvailableApplicanttableData.cases.filter(val =>{
        return val.markSelection == false;
      });

      let selectedApplicantData = action.payload.slice();
          selectedApplicantData && selectedApplicantData.forEach(object => {
            object.markSelection = false;
          });
      let combineSelectedTable = [...state.selectedApplicantTableData.cases, ...selectedApplicantData];

      return {
        ...state,
        AvailableApplicanttableData: { ...state.AvailableApplicanttableData, cases: remainingAvailableApplicantItem, AvailableApplicantSeletableItem: [] },
        selectedApplicantTableData: {...state.selectedApplicantTableData, cases: combineSelectedTable, total: combineSelectedTable.length }
      };
    }

    case preregisterApplicantsTypes.MOVE_APPLICANT_TO_AVAILABLE_TABLE: {
      let remainingSelectedApplicantItem = state.selectedApplicantTableData.cases.filter(val =>{
        return val.markSelection == false;
      });
      let selectedApplicantData = action.payload.slice();
          selectedApplicantData && selectedApplicantData.forEach(object => {
            object.markSelection = false;
          });
      let combineAvailableTable = [...state.AvailableApplicanttableData.cases, ...selectedApplicantData];
      return {
        ...state,
        selectedApplicantTableData: {...state.selectedApplicantTableData, cases: remainingSelectedApplicantItem, selectedApplicantSelectableItem:[] },

        AvailableApplicanttableData: { ...state.AvailableApplicanttableData, cases: combineAvailableTable, total: combineAvailableTable.length },
      };

    }

    case preregisterApplicantsTypes.MOVE_APPLICANT_RESET_TABLE_RECORDS:{
      return {
        ...state,
        AvailableApplicanttableData:  {
          columns:[
            "markSelection", "caseManagerId", "applicant", "caseId", "personId", "client", "eyStatus", "casePhase"
          ],
          cases:[],
          AvailableApplicantSeletableItem:[],
          total: 0
        },
        selectedApplicantTableData: {
          columns:[
            "markSelection", "caseManagerId", "applicant", "caseId", "personId", "client", "eyStatus", "casePhase"
          ],
          cases:[],
          selectedApplicantSelectableItem:[],
          total: 0
        },
        onsearchFilter: false
      }
    };
    case preregisterApplicantsTypes.MOVE_APPLICANT_SEARCH_FILTER: {
      return {
        ...state,
        onsearchFilter: action.payload
      };
    }

    case preregisterApplicantsTypes.GET_FILTERS_MOVEAPPLICANT_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };

    case preregisterApplicantsTypes.MOVE_APPLICANT_SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };
   
    default:
      return state;
  }
};

export { initialState };
export default moveApplicantReducer;



// WEBPACK FOOTER //
// ./src/ui/features/PreregisterApplicants/state/moveApplicantReducer.js